var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mb-n12" },
        [
          _c("v-col", { attrs: { cols: "2" } }),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _vm.success
                    ? _c(
                        "v-alert",
                        {
                          attrs: {
                            type: "success",
                            transition: "scale-transition",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "You're all set! Check your email for confirmation and start enjoying the benefits of your account."
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.error
                    ? _c(
                        "v-alert",
                        {
                          attrs: {
                            type: "error",
                            dismissible: "",
                            transition: "scale-transition",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("register.messages.error.fail")
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "Registration failed! Please try again later."
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorOrgExists
                    ? _c(
                        "v-alert",
                        {
                          attrs: {
                            type: "error",
                            dismissible: "",
                            transition: "scale-transition",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("register.messages.error.orgexists")
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "Company name already registered! Please choose another one."
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorEmailExists
                    ? _c(
                        "v-alert",
                        {
                          attrs: {
                            type: "error",
                            dismissible: "",
                            transition: "scale-transition",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("register.messages.error.emailexists")
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "Email is already in use! Please choose another one."
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-col", { attrs: { cols: "2" } }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.success
        ? _c(
            "v-row",
            [
              _c("v-col", {
                staticClass: "d-none d-lg-block",
                attrs: { cols: "1" },
              }),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "v-stepper",
                    {
                      attrs: { vertical: "", color: "secondary" },
                      model: {
                        value: _vm.buyStep,
                        callback: function ($$v) {
                          _vm.buyStep = $$v
                        },
                        expression: "buyStep",
                      },
                    },
                    [
                      _c(
                        "v-stepper-step",
                        {
                          staticClass: "font-weight-black reg-title",
                          attrs: {
                            step: "1",
                            complete: _vm.buyStep > 1,
                            disabled: _vm.userHasSubscription,
                          },
                        },
                        [_vm._v("\n        Register\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "1" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { "max-height": "600px" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "mt-n4" },
                                [
                                  _c("v-col", [
                                    _c("span", [
                                      _vm._v("Have an account? "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "login-element",
                                          on: {
                                            click: function ($event) {
                                              return _vm.toLogin()
                                            },
                                          },
                                        },
                                        [_vm._v("Log in")]
                                      ),
                                      _vm._v(" for faster checkout."),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "form",
                                {
                                  attrs: { "no-validate": "" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.register()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "organizationName",
                                              name: "organizationName",
                                              label: _vm.$t(
                                                "global.form['company.label']"
                                              ),
                                              "error-messages":
                                                _vm.organizationNameErrorsNonUnique(
                                                  _vm.$v.registerBuy,
                                                  "organizationName"
                                                ),
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.registerBuy.organizationName.$touch()
                                              },
                                              blur: function ($event) {
                                                return _vm.$v.registerBuy.organizationName.$touch()
                                              },
                                              keypress: _vm.blockChars,
                                            },
                                            model: {
                                              value:
                                                _vm.$v.registerBuy
                                                  .organizationName.$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.registerBuy
                                                    .organizationName,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.registerBuy.organizationName.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "email",
                                              name: "email",
                                              label: _vm.$t(
                                                "global.form['email.label']"
                                              ),
                                              "error-messages": _vm.emailErrors(
                                                _vm.$v.registerBuy
                                              ),
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.registerBuy.email.$touch()
                                              },
                                              blur: function ($event) {
                                                return _vm.$v.registerBuy.email.$touch()
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.$v.registerBuy.email.$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.registerBuy.email,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.registerBuy.email.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-n6" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "firstName",
                                              name: "firstName",
                                              label: _vm.$t(
                                                "global.form['firstname.label']"
                                              ),
                                              "error-messages":
                                                _vm.firstNameErrors(
                                                  _vm.$v.registerBuy
                                                ),
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.registerBuy.firstName.$touch()
                                              },
                                              blur: function ($event) {
                                                return _vm.$v.registerBuy.firstName.$touch()
                                              },
                                              keypress: _vm.blockChars,
                                            },
                                            model: {
                                              value:
                                                _vm.$v.registerBuy.firstName
                                                  .$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.registerBuy.firstName,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.registerBuy.firstName.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "lastName",
                                              name: "lastName",
                                              label: _vm.$t(
                                                "global.form['lastname.label']"
                                              ),
                                              "error-messages":
                                                _vm.lastNameErrors(
                                                  _vm.$v.registerBuy
                                                ),
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.registerBuy.lastName.$touch()
                                              },
                                              blur: function ($event) {
                                                return _vm.$v.registerBuy.lastName.$touch()
                                              },
                                              keypress: _vm.blockChars,
                                            },
                                            model: {
                                              value:
                                                _vm.$v.registerBuy.lastName
                                                  .$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.registerBuy.lastName,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.registerBuy.lastName.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-n6" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "secondary",
                                                block: "",
                                                type: "submit",
                                                disabled:
                                                  _vm.$v.registerBuy.$invalid,
                                              },
                                            },
                                            [_vm._v("Register")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-col"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-step",
                        {
                          class: _vm.userHasSubscription
                            ? "font-weight-black reg-title error--text"
                            : "font-weight-black reg-title",
                          attrs: {
                            step: "2",
                            complete: _vm.buyStep > 2,
                            rules: [() => !_vm.userHasSubscription],
                          },
                        },
                        [
                          _vm._v("\n          Subscribe\n          "),
                          _vm.userHasSubscription
                            ? _c(
                                "div",
                                { staticClass: "reg-title-error text-no-wrap" },
                                [
                                  _vm._v("You're already subscribed! Click "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "login-element-error",
                                      on: {
                                        click: function ($event) {
                                          return _vm.gotoSubscription()
                                        },
                                      },
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(" to manage your subscription."),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "2" } },
                        [
                          _vm.showEstimate
                            ? _c(
                                "v-card",
                                { attrs: { "max-height": "900px" } },
                                [
                                  _vm.updateCheckout
                                    ? _c("learner-update-plan", {
                                        attrs: {
                                          planNickname:
                                            _vm.registerBuy.planNickname,
                                          "checkout-user-dto": _vm.userAccount,
                                          subscription: _vm.ecomSubscription,
                                          allowPlanChange: false,
                                          showTitleBar: false,
                                          enterpriseToStripe: false,
                                          planToAdd: _vm.planToAdd,
                                          couponCode: _vm.couponCode,
                                          updateBillingMode: false,
                                        },
                                        on: {
                                          done: _vm.onDoneCheckout,
                                          cancel: _vm.onCancelCheckout,
                                        },
                                      })
                                    : _c("learner-stratergy", {
                                        attrs: {
                                          planNickname:
                                            _vm.registerBuy.planNickname,
                                          "checkout-user-dto": _vm.userAccount,
                                          subscription: _vm.elbSubscription,
                                          subscriptions: _vm.userSubscriptions,
                                          allowPlanChange: false,
                                          showTitleBar: false,
                                          couponCode: _vm.couponCode,
                                        },
                                        on: {
                                          done: _vm.onDoneCheckout,
                                          cancel: _vm.onCancelCheckout,
                                        },
                                      }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-overlay",
                        { attrs: { absolute: true, value: _vm.loading } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", size: "64" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-col", {
                staticClass: "d-none d-lg-block",
                attrs: { cols: "1" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }